exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TagEditor {\n  padding: 10px 5px;\n  border-bottom: 1px solid var(--color-alabaster);\n}\n", ""]);

